import React, { useEffect, useState, useRef, useCallback } from "react";
import {useSize} from "react-hook-size";
import Spot from "../../common/spot/spot";
import {Card, Accordion, Button, Container, Row, Col, ListGroup, Navbar, Nav, Modal} from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as turf from '@turf/turf'
import { faChevronDown, faChevronLeft, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import ApiV2 from "../../common/apiV2";
import Map, {Marker, GeolocateControl, ScaleControl, NavigationControl} from 'react-map-gl';
import mapboxgl from 'mapbox-gl';
import { maxBy, minBy } from "lodash";
import WebMercatorViewport from "viewport-mercator-project"

const MAPBOX_TOKEN = 'pk.eyJ1IjoiY29uZ2RvZSIsImEiOiJja205NmhqY2UxZXpuMnVwbTV0dDFvZjh4In0.aadaTJC6ZbASBxqpX8Il3A';
const geolocateControlStyle= {right: 10, bottom: 135};
const scaleControlStyle = {left: 10, bottom: 40};
const navControlStyle = {right: 10, bottom: 40};

const getMinOrMax = (markers, minOrMax: "max" | "min", latOrLng: "latitude" | "longitude") => {
    if(markers !== null){
        if (minOrMax === "max") {
          return (maxBy(markers, value => value[latOrLng]))[latOrLng];
        } else {
          return (minBy(markers, value => value[latOrLng]))[latOrLng];
        }
    }
  };
  
  const getBounds = (markers) => {
    const maxLat = getMinOrMax(markers, "max", "latitude");
    const minLat = getMinOrMax(markers, "min", "latitude");
    const maxLng = getMinOrMax(markers, "max", "longitude");
    const minLng = getMinOrMax(markers, "min", "longitude");
  
    const southWest = [minLng, minLat];
    const northEast = [maxLng, maxLat];

    return [southWest, northEast];
  };

function ViewShareList(props) {
    const [toggleDownState, setToggleDownState] = useState(true);
    const [sharelist, setSharelist] = useState({});
    const [flag, setFlag] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRec, setSelectedRec] = useState(null);
    const [markerBounds, setMarkerBounds] = useState(null);
    const [recList, setRecList] = useState([]);
    const [mapStyle, setMapStyle] = useState("mapbox://styles/congdoe/ckmxmhljb0z7918mrmvrro060");
    const [currentLocation, setCurrentLocation] = useState({latitude: null, longitude: null});
    const [markers, setMarkers] = useState(null);
    const [viewport, setViewport] = useState({});
    const [inProfile, setInProfile] = useState(false);
    const [sharelistId, setSharelistId] = useState(null);

    useEffect(() => {
        // How you get the param id from route
        if(props.match.path.includes("/profile/")){
            setInProfile(true);
        }
        try {
            console.log("Fetching users following and your followers")
            setSharelistId(props.match.params.id);
            
        } catch (error) {
            console.log("Unable to fetch sharelist");
        }

        }
        ,[]
    );

    useEffect(() => {
        const currTime = (new Date()).getHours();
        console.log("TIME: ", currTime)
        if (!(currTime > 6 && currTime < 18 )){
            setMapStyle("mapbox://styles/congdoe/ckmxn4ko50zv917pduviuis4w");
        }
    },[]);

    useEffect(() => {
            const fetchSharelists = async () => {
                if(sharelistId != null){
                    try {
    
                        console.log("Getting sharelist with id: ", sharelistId)
                        const {data} = await ApiV2.getSharelistPlaces(sharelistId);

                        const sharelistDataResponse = await ApiV2.getSharelist(sharelistId);
                        if(data.length === 0){
                            var thisSharelist = {
                                data: sharelistDataResponse.data.data,
                                places: [],
                            }
    
                            setSharelist(thisSharelist);
                            return;
                        } else {
                            setRecList(data);
            
                            var spotMarkers = [];
                            for (var i = 0; i < data.length; i++) { 
                                spotMarkers.push({
                                    id: i,
                                    longitude: data[i].mapboxData.center[0],
                                    latitude: data[i].mapboxData.center[1],
                                })
                            }
                            setMarkers(spotMarkers);
            
                            var sharelist = {
                                data: sharelistDataResponse.data.data,
                                places: data,
                            }
    
                            setSharelist(sharelist);
            
                            console.log("HISTORY: ", props.history);
                        }
                    } catch (error) {
                        console.log("ERROR: ", error);
                    }


                }
            }
            fetchSharelists();
        }
    ,[sharelistId]
    );

    useEffect(() => 
        {
            const fetchSharelists = async () => {
                if (sharelistId){
                    const {data} = await ApiV2.getSharelistPlaces(sharelistId)
                    setRecList(data);

                    var spotMarkers = [];
                    for (var i = 0; i < data.length; i++) { 
                        spotMarkers.push({
                            id: i,
                            longitude: data[i].mapboxData.center[0],
                            latitude: data[i].mapboxData.center[1],
                        })
                    }
                    setMarkers(spotMarkers);

                    var sharelist = {
                        data: props.selectedSharelist.data,
                        places: data,
                    }
            
                    props.setSelectedSharelist(sharelist);
                    setSharelist(sharelist);
                }
                console.log("HISTORY: ", props.history);
            }
            fetchSharelists();
            setFlag(false);
        }
    ,[]
    );

    useEffect(() => 
    {
        const updateMarkerBounds = () => {
            const newBounds = getBounds(markers);
            setMarkerBounds(newBounds);
        }
        updateMarkerBounds();
    }
,[markers]
);

useEffect(() => {
    if (viewport !== {}){
            if (markerBounds && markerBounds[0][0] !== undefined) {
                var newViewport = new WebMercatorViewport(viewport).fitBounds(markerBounds, {
                    padding: 60,
                    maxZoom: 14,
                });
                setViewport(newViewport);
    }
}
  }, [markerBounds]);

useEffect(() => {
    if (viewport !== {}){
            if (markerBounds && markerBounds[0][0] !== undefined) {
                var newViewport = new WebMercatorViewport(viewport).fitBounds(markerBounds, {
                    padding: 60,
                    maxZoom: 14,
                });
                setViewport(newViewport);
    }
}
  }, [markerBounds]);

    const mapRef = useRef();
    const mapContainerRef = useRef(null);
    const { width, height } = useSize(mapContainerRef);

    const openModal = useCallback(
        (place) => {
            setIsOpen(true);
            setSelectedRec(place);
        },
        []
    );

    const closeModal = useCallback(
        () => {
            setIsOpen(false);
            setSelectedRec(null);
        },
        []
    );

    const deleteSharelistPlace = useCallback(
        async (place) => {
            try {
                const response = ApiV2.deleteSharelistPlace(props.selectedSharelist.data.id,place.id);
    
                response.then((val) => {
                    setFlag(true);
                    setIsOpen(false);
                    props.notifyInfo(
                        "Successfully deleted " + place.name
                    );
                    closeModal();
                });
            } catch (e) {
                console.log("Error: ", JSON.stringify(e));
                props.notifyFailure("Failed to delete recomendation.", JSON.stringify(e));
            }
        }

    ,[]);

    const getLocation = useCallback((location) => {
        setCurrentLocation(location.coords);
    },[]);

    const getDistance = (place) => {
        if(currentLocation.longitude){
            var from = turf.point([currentLocation.longitude, currentLocation.latitude]);
            var to = turf.point([place.mapboxData.center[0], place.mapboxData.center[1]]);
            var options = {units: 'miles'};
    
            var distance = turf.distance(from, to, options);
            return distance.toFixed(1);
        }
        return
    }

    const renderSpotMarkers = () => {
        const markers = recList.map(spot => {
            return(
                <Marker latitude={spot.mapboxData.center[1]} longitude={spot.mapboxData.center[0]} offsetLeft={-12} offsetTop={-30}>
                {/* <FontAwesomeIcon onClick={() => togglePopup(!showPopup)} className='text-primary fa-2x' icon={faMapMarkerAlt} /> */}
                    <FontAwesomeIcon className='text-primary fa-2x' icon={faMapMarkerAlt} />
                </Marker>
            );
        });
        return markers;
    }

    const renderRecommendations = () => {
        const places = recList.map(place => {
            return(
                <Spot
                    place={place}
                    openModal={openModal}
                    getDistance={getDistance}
                />
            );
        });
        return places;
    }
        
    return(
    <>
        <Modal show={isOpen}
            onHide={() => closeModal()}
            centered>
            <Modal.Body>
                <Col>
                    <Button onClick={() => closeModal()}
                        className="blue"
                        variant="light"
                        size="lg"
                        block>
                        Share
                    </Button>
                    <Button onClick={() => closeModal()}
                        className="blue"
                        variant="light"
                        size="lg"
                        block>
                        Cancel
                    </Button>
                </Col>
            </Modal.Body>
        </Modal>

        <Navbar expand="lg" bg="light" variant="light" sticky="top" className="top-nav nav-fill">
            <Nav>
                <Nav.Link className="p-0">
                    <Button variant="link" onClick={() => props.history.goBack()}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </Button>
                </Nav.Link>
            </Nav>
            <Navbar.Brand className="brand">{sharelist.data?.name}</Navbar.Brand>
        </Navbar>
        <Accordion defaultActiveKey="0" className="mb-1">
            <Card className="p-0 full-width">
                <Card.Header className="p-0">
                <Accordion.Collapse eventKey="0" className="full-width">
                <Map
                    ref={mapRef}
                    {...viewport}
                    width="100%"
                    height="50vh"
                    mapStyle={mapStyle}
                    onViewportChange={viewport => setViewport(viewport)}
                    mapboxApiAccessToken={MAPBOX_TOKEN}
                    className='rounded'
                >
                {renderSpotMarkers()}
                <GeolocateControl
                style={geolocateControlStyle}
                positionOptions={{enableHighAccuracy: false}}
                trackUserLocation={true}
                onGeolocate={getLocation}
                onViewportChange={() => {console.log("Viewport update")}}
                auto
                />
                <NavigationControl showCompass={false} style={navControlStyle} />
                <ScaleControl maxWidth={100} unit="imperial" style={scaleControlStyle} />
                </Map>
                </Accordion.Collapse>
                <Container>
                <Row className="justify-content-center">
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                    <FontAwesomeIcon id="toggle-down" icon={faChevronDown} />
                </Accordion.Toggle>
                </Row>
                </Container>
                </Card.Header>
            </Card>
            </Accordion>
            <ListGroup className="full-width bottom-pad">
                {renderRecommendations()}
            </ListGroup>
    </>
    );
}

export default withRouter(ViewShareList);

ViewShareList.propTypes = {
    setSelectedSharelist: PropTypes.func.isRequired,
    // notifySuccess: PropTypes.func.isRequired,
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired,
};
  

